export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
    getSearchFields: state => state.searchFields,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen
}
